import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "inherit",
      d: "M15 13.72a1 1 0 0 1-.777-.373L9.95 8.065l-2.715 2.937a1 1 0 0 1-1.545-.092L.19 3.305a1 1 0 1 1 1.62-1.17l4.785 6.612 2.67-2.89a1 1 0 0 1 1.5.05l5 6.185A1 1 0 0 1 15 13.72",
      class: "fill-primary"
    }, null, -1),
    _createElementVNode("path", {
      fill: "inherit",
      d: "M13 16H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3M3 2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z",
      class: "fill-secondary"
    }, null, -1)
  ])))
}
export default { render: render }